(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-cards"] && !Shopify.designMode) return;
  try {
    
  function initCityFilters(root) {
    var scope = root || document;
    var filters = scope.querySelectorAll('[data-city-filter]');

    filters.forEach(function(filter) {
      var section = filter.closest('.content-cards-section');
      if (!section) return;

      var buttons = filter.querySelectorAll('[data-city-filter-button]');
      var cards = section.querySelectorAll('[data-city-card]');
      var shouldEnable = filter.getAttribute('data-city-filter-enabled') === 'true' || cards.length > 6;

      if (!shouldEnable) return;

      filter.classList.add('is-ready');

      function applyCity(city) {
        buttons.forEach(function(button) {
          var isActive = button.getAttribute('data-city-filter-button') === city;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        cards.forEach(function(card) {
          var cardCity = card.getAttribute('data-city-card');
          card.classList.toggle('is-hidden', cardCity !== city);
        });
      }

      if (filter.dataset.cityFilterReady === 'true') return;
      filter.dataset.cityFilterReady = 'true';

      buttons.forEach(function(button) {
        button.addEventListener('click', function() {
          applyCity(button.getAttribute('data-city-filter-button'));
        });
      });

      applyCity('中山');
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initCityFilters(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initCityFilters(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-city-cards"] && !Shopify.designMode) return;
  try {
    
  function initCityFilters(root) {
    var scope = root || document;
    var filters = scope.querySelectorAll('[data-city-filter]');

    filters.forEach(function(filter) {
      var section = filter.closest('.project-city-cards-section');
      if (!section) return;

      var buttons = filter.querySelectorAll('[data-city-filter-button]');
      var cards = section.querySelectorAll('[data-city-card]');
      var shouldEnable = filter.getAttribute('data-city-filter-enabled') === 'true' || cards.length > 6;

      if (!shouldEnable) return;

      filter.classList.add('is-ready');

      function applyCity(city) {
        buttons.forEach(function(button) {
          var isActive = button.getAttribute('data-city-filter-button') === city;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        cards.forEach(function(card) {
          var cardCity = card.getAttribute('data-city-card');
          card.classList.toggle('is-hidden', cardCity !== city);
        });
      }

      if (filter.dataset.cityFilterReady === 'true') return;
      filter.dataset.cityFilterReady = 'true';

      buttons.forEach(function(button) {
        button.addEventListener('click', function() {
          applyCity(button.getAttribute('data-city-filter-button'));
        });
      });

      applyCity('中山');
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initCityFilters(document);
  });

  document.addEventListener('shopify:section:load', function(event) {
    initCityFilters(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-detail-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-project-chip]');
    if (!chip) return;

    var isActive = chip.classList.toggle('is-active');
    chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-detail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-project-chip]');
    if (!chip) return;

    var isActive = chip.classList.toggle('is-active');
    chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-media-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-project-media-thumb]');
    if (!thumb) return;

    var switcher = thumb.closest('[data-project-media-switcher]');
    if (!switcher) return;

    var stage = switcher.querySelector('[data-project-media-stage]');
    var title = switcher.querySelector('[data-project-media-title]');
    var note = switcher.querySelector('[data-project-media-note]');
    if (!stage || !title || !note) return;

    stage.innerHTML = thumb.dataset.mediaHtml || '';
    stage.className = 'project-media-card__image project-media-card__image--' + (thumb.dataset.mediaFit || 'contain');
    stage.dataset.mediaZoomSrc = thumb.dataset.mediaZoomSrc || '';
    stage.dataset.mediaZoomTitle = thumb.dataset.mediaTitle || '';
    stage.setAttribute('aria-label', '放大圖片：' + (thumb.dataset.mediaTitle || ''));
    title.textContent = thumb.dataset.mediaTitle || '';
    note.textContent = thumb.dataset.mediaNote || '';

    switcher.querySelectorAll('[data-project-media-thumb]').forEach(function (button) {
      button.classList.toggle('is-active', button === thumb);
      button.setAttribute('aria-pressed', button === thumb ? 'true' : 'false');
    });
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-project-media-zoom]');
    if (!trigger) return;

    var src = trigger.dataset.mediaZoomSrc || '';
    if (!src) return;

    var lightbox = document.querySelector('[data-project-media-lightbox]');
    if (!lightbox) return;

    var image = lightbox.querySelector('[data-project-media-lightbox-image]');
    var title = lightbox.querySelector('[data-project-media-lightbox-title]');
    image.src = src;
    image.alt = trigger.dataset.mediaZoomTitle || '';
    title.textContent = trigger.dataset.mediaZoomTitle || '';
    lightbox.hidden = false;
    document.documentElement.classList.add('project-media-lightbox-open');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      var trigger = event.target.closest('[data-project-media-zoom]');
      if (trigger) {
        event.preventDefault();
        trigger.click();
      }
    }

    if (event.key === 'Escape') {
      var lightbox = document.querySelector('[data-project-media-lightbox]');
      if (lightbox && !lightbox.hidden) {
        lightbox.hidden = true;
        document.documentElement.classList.remove('project-media-lightbox-open');
      }
    }
  });

  document.addEventListener('click', function (event) {
    var close = event.target.closest('[data-project-media-lightbox-close]');
    if (!close) return;

    var lightbox = close.closest('[data-project-media-lightbox]');
    if (!lightbox) return;

    lightbox.hidden = true;
    document.documentElement.classList.remove('project-media-lightbox-open');
  });

  } catch(e) { console.error(e); }
})();
})();
